import { NonFaceToFaceBookingSchedulesInfo } from '@/models/diagnosis';
import { AvailableBookingTimeSlotsQuery } from '@/types/bff/gql-schema';
import { useAvailableBookingTimeSlotsQuery } from './telemedicine.gql.impl';

const parseNonFaceToFaceBookingSchedule = (data: AvailableBookingTimeSlotsQuery) => {
  const schedules = data.availableBookingTimeSlots.map((scheduleInfo) => {
    return {
      displayName: scheduleInfo.displayName,
      status: scheduleInfo.status,
      targetDate: scheduleInfo.targetDate,
      schedules: scheduleInfo.schedules.map((schedule) => ({
        bookingStatus: schedule.bookingStatus,
        startTimeSlot: schedule.startTimeSlot,
        endTimeSlot: schedule.endTimeSlot,
        remainingCount: schedule.remainingCount,
      })),
    };
  });

  return new NonFaceToFaceBookingSchedulesInfo(schedules);
};

const useGetBookingSchedules = () => {
  const { data = new NonFaceToFaceBookingSchedulesInfo([]), isFetched: isBookingSchedulesFetched } =
    useAvailableBookingTimeSlotsQuery(
      {},
      {
        select: parseNonFaceToFaceBookingSchedule,
      }
    );

  return { bookingSchedulesInfo: data, isBookingSchedulesFetched };
};

export default useGetBookingSchedules;
